import React from "react";
var myDate = new Date();
var hrs = myDate.getHours();

var greet;

if (hrs < 12) greet = "Good Morning";
else if (hrs >= 12 && hrs <= 17) greet = "Good Afternoon";
else if (hrs >= 17 && hrs <= 24) greet = "Good Evening";

function Wishes() {
  return <div style={{color:"var(--wishes-color)",fontSize:"28px"}}>{greet}</div>;
}
export default Wishes;
